import { createActions } from 'redux-actions';

export default createActions(
  {
    SATISFACTION_SAVE_EMAIL_GLOBAL_SETTINGS_REQUEST: [
      (payload) => payload,
      (__, meta) => meta,
    ],
    SATISFACTION_SAVE_EMAIL_CONTACT_LEVEL_SETTINGS_REQUEST: [
      (payload) => payload,
      (__, meta) => meta,
    ],
    SATISFACTION_SAVE_EMAIL_LANGUAGE_LEVEL_SETTINGS_REQUEST: [
      (payload) => payload,
      (__, meta) => meta,
    ],

    // ----------------------------------------------------------

    SATISFACTION_SAVE_CHAT_GLOBAL_SETTINGS_REQUEST: [
      (payload) => payload,
      (__, meta) => meta,
    ],
    SATISFACTION_SAVE_CHAT_CONTACT_LEVEL_SETTINGS_REQUEST: [
      (payload) => payload,
      (__, meta) => meta,
    ],
    SATISFACTION_SAVE_CHAT_LANGUAGE_LEVEL_SETTINGS_REQUEST: [
      (payload) => payload,
      (__, meta) => meta,
    ],

    // ----------------------------------------------------------

    SATISFACTION_SAVE_DIXA_MESSENGER_GLOBAL_SETTINGS_REQUEST: [
      (payload) => payload,
      (__, meta) => meta,
    ],
    SATISFACTION_SAVE_DIXA_MESSENGER_CONTACT_LEVEL_SETTINGS_REQUEST: [
      (payload) => payload,
      (__, meta) => meta,
    ],
    SATISFACTION_SAVE_DIXA_MESSENGER_LANGUAGE_LEVEL_SETTINGS_REQUEST: [
      (payload) => payload,
      (__, meta) => meta,
    ],
  },

  // ----------------------------------------------------------

  'SATISFACTION_SAVE_EMAIL_GLOBAL_SETTINGS_SUCCEEDED',
  'SATISFACTION_SAVE_EMAIL_GLOBAL_SETTINGS_FAILED',

  'SATISFACTION_SAVE_EMAIL_CONTACT_LEVEL_SETTINGS_SUCCEEDED',
  'SATISFACTION_SAVE_EMAIL_CONTACT_LEVEL_SETTINGS_FAILED',

  'SATISFACTION_LOAD_EMAIL_ALL_LEVELS_SETTINGS_REQUEST',
  'SATISFACTION_LOAD_EMAIL_ALL_LEVELS_SETTINGS_SUCCEEDED',
  'SATISFACTION_LOAD_EMAIL_ALL_LEVELS_SETTINGS_FAILED',

  'SATISFACTION_LOAD_EMAIL_GLOBAL_SETTINGS_REQUEST',
  'SATISFACTION_LOAD_EMAIL_GLOBAL_SETTINGS_SUCCEEDED',
  'SATISFACTION_LOAD_EMAIL_GLOBAL_SETTINGS_FAILED',

  'SATISFACTION_LOAD_EMAIL_CONTACT_LEVEL_SETTINGS_REQUEST',
  'SATISFACTION_LOAD_EMAIL_CONTACT_LEVEL_SETTINGS_SUCCEEDED',
  'SATISFACTION_LOAD_EMAIL_CONTACT_LEVEL_SETTINGS_FAILED',

  'SATISFACTION_LOAD_EMAIL_LANGUAGE_LEVEL_SETTINGS_REQUEST',
  'SATISFACTION_LOAD_EMAIL_LANGUAGE_LEVEL_SETTINGS_SUCCEEDED',
  'SATISFACTION_LOAD_EMAIL_LANGUAGE_LEVEL_SETTINGS_FAILED',

  'SATISFACTION_SAVE_EMAIL_LANGUAGE_LEVEL_SETTINGS_SUCCEEDED',
  'SATISFACTION_SAVE_EMAIL_LANGUAGE_LEVEL_SETTINGS_FAILED',

  // ----------------------------------------------------------

  'SATISFACTION_INITIALIZE_REQUEST',
  'SATISFACTION_INITIALIZE_SUCCEEDED',
  'SATISFACTION_INITIALIZE_FAILED',

  // ----------------------------------------------------------

  'SATISFACTION_LOAD_CHAT_ALL_LEVELS_SETTINGS_REQUEST',
  'SATISFACTION_LOAD_CHAT_ALL_LEVELS_SETTINGS_SUCCEEDED',
  'SATISFACTION_LOAD_CHAT_ALL_LEVELS_SETTINGS_FAILED',

  'SATISFACTION_LOAD_CHAT_GLOBAL_SETTINGS_REQUEST',
  'SATISFACTION_LOAD_CHAT_GLOBAL_SETTINGS_SUCCEEDED',
  'SATISFACTION_LOAD_CHAT_GLOBAL_SETTINGS_FAILED',

  'SATISFACTION_LOAD_CHAT_CONTACT_LEVEL_SETTINGS_REQUEST',
  'SATISFACTION_LOAD_CHAT_CONTACT_LEVEL_SETTINGS_SUCCEEDED',
  'SATISFACTION_LOAD_CHAT_CONTACT_LEVEL_SETTINGS_FAILED',

  'SATISFACTION_LOAD_CHAT_LANGUAGE_LEVEL_SETTINGS_REQUEST',
  'SATISFACTION_LOAD_CHAT_LANGUAGE_LEVEL_SETTINGS_SUCCEEDED',
  'SATISFACTION_LOAD_CHAT_LANGUAGE_LEVEL_SETTINGS_FAILED',

  'SATISFACTION_SAVE_CHAT_GLOBAL_SETTINGS_SUCCEEDED',
  'SATISFACTION_SAVE_CHAT_GLOBAL_SETTINGS_FAILED',

  'SATISFACTION_SAVE_CHAT_CONTACT_LEVEL_SETTINGS_SUCCEEDED',
  'SATISFACTION_SAVE_CHAT_CONTACT_LEVEL_SETTINGS_FAILED',

  'SATISFACTION_SAVE_CHAT_LANGUAGE_LEVEL_SETTINGS_SUCCEEDED',
  'SATISFACTION_SAVE_CHAT_LANGUAGE_LEVEL_SETTINGS_FAILED',

  // ----------------------------------------------------------

  'SATISFACTION_LOAD_DIXA_MESSENGER_ALL_LEVELS_SETTINGS_REQUEST',
  'SATISFACTION_LOAD_DIXA_MESSENGER_ALL_LEVELS_SETTINGS_SUCCEEDED',
  'SATISFACTION_LOAD_DIXA_MESSENGER_ALL_LEVELS_SETTINGS_FAILED',

  'SATISFACTION_LOAD_DIXA_MESSENGER_GLOBAL_SETTINGS_REQUEST',
  'SATISFACTION_LOAD_DIXA_MESSENGER_GLOBAL_SETTINGS_SUCCEEDED',
  'SATISFACTION_LOAD_DIXA_MESSENGER_GLOBAL_SETTINGS_FAILED',

  'SATISFACTION_LOAD_DIXA_MESSENGER_CONTACT_LEVEL_SETTINGS_REQUEST',
  'SATISFACTION_LOAD_DIXA_MESSENGER_CONTACT_LEVEL_SETTINGS_SUCCEEDED',
  'SATISFACTION_LOAD_DIXA_MESSENGER_CONTACT_LEVEL_SETTINGS_FAILED',

  'SATISFACTION_LOAD_DIXA_MESSENGER_LANGUAGE_LEVEL_SETTINGS_REQUEST',
  'SATISFACTION_LOAD_DIXA_MESSENGER_LANGUAGE_LEVEL_SETTINGS_SUCCEEDED',
  'SATISFACTION_LOAD_DIXA_MESSENGER_LANGUAGE_LEVEL_SETTINGS_FAILED',

  'SATISFACTION_SAVE_DIXA_MESSENGER_GLOBAL_SETTINGS_SUCCEEDED',
  'SATISFACTION_SAVE_DIXA_MESSENGER_GLOBAL_SETTINGS_FAILED',

  'SATISFACTION_SAVE_DIXA_MESSENGER_CONTACT_LEVEL_SETTINGS_SUCCEEDED',
  'SATISFACTION_SAVE_DIXA_MESSENGER_CONTACT_LEVEL_SETTINGS_FAILED',

  'SATISFACTION_SAVE_DIXA_MESSENGER_LANGUAGE_LEVEL_SETTINGS_SUCCEEDED',
  'SATISFACTION_SAVE_DIXA_MESSENGER_LANGUAGE_LEVEL_SETTINGS_FAILED',
);
